module.exports = __webpack_public_path__ + "static/media/intro-desktop-en.5c7ab456.png";